import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { useMutation } from "@apollo/react-hooks";
import IconButton from "components/icon-button";
import Icon from "components/icon";

const RTMPActionButton = ({ className, eventId, componentName, icon, actionMutation, onAction, intl }) => {
  const [rtmpAction] = useMutation(actionMutation);

  const handleClick = () => {
    if (!componentName && !eventId) {
      return;
    }

    const variables = { eventId, componentName };
    const updatedData = rtmpAction({ variables });

    return updatedData
      .then(({ data, error }) => {
        onAction(!error);
      })
      .catch(() => {
        onAction(false);
      });
  };

  return (
    <IconButton className={className} onClick={handleClick}>
      <Icon name={icon} />
    </IconButton>
  );
};

RTMPActionButton.propTypes = {
  /**
   ** Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   ** ID de evento
   **/
  eventId: PropTypes.string,
  /**
   ** Nombre de componente rtmp
   **/
  componentName: PropTypes.string,
  /**
   ** Query Graphql de la acción rtmp
   **/
  actionMutation: PropTypes.object,
  /**
   ** Nombre del icono
   **/
  icon: PropTypes.string,
  /**
   ** Callback que se llama al realizar la acción o fallar
   **/
  onAction: PropTypes.func,
};

export default injectIntl(RTMPActionButton);
